module.exports = __webpack_public_path__ + "img/help-circle-disabled.ecbbc5a6.svg";